/* eslint-disable react/prop-types */
// @flow

import * as React from 'react'
import linkViewModel from '@vimcar/shared-utils/linkViewModel'
import RadioButtonGroup from '@vimcar/shared-components/components/RadioButtonGroup'

import i18n from '#utils/i18n'
import mkViewModel, { type ViewModel } from './viewModel'
import styles from '../../styles.css'

const tp = i18n.prefix('components.LanguagePreferences')

const LanguagePreferences = ({
  className,
  titleClassName,
  viewModel,
}) => (
  <section className={className}>
    <h3 className={titleClassName}>{tp('default-language')}</h3>
    <RadioButtonGroup
      className={styles.radioGroup}
      name='default-language'
      onChange={viewModel.handleLanguageChange}
      valueSelected={viewModel.currentLanguage}
      >
      {viewModel.languageOptions.map(({ code, label, disabled }) => (
        <RadioButtonGroup.RadioButton
          disabled={disabled}
          key={code}
          label={label}
          value={code}
          />
      ))}
    </RadioButtonGroup>
  </section>
)

export default linkViewModel<*, ViewModel>(
  mkViewModel,
  LanguagePreferences
)
